import { lazy, Suspense } from 'react';

// Downloaded only where it shows, so staging and production never fetch it. The
// `production` build renders in a production build too, which is what the dev stage runs.
const ReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools/production').then((devtools) => ({
    default: devtools.ReactQueryDevtools,
  })),
);

/**
 * TanStack Query's devtools: every query and mutation, its state and its data (D-072).
 * Its toggle sits bottom right, clear of the router's bottom left. It reads the query
 * client from `QueryClientProvider`, so it must render inside it.
 */
export function QueryDevtools() {
  return (
    <Suspense fallback={null}>
      <ReactQueryDevtools buttonPosition="bottom-right" />
    </Suspense>
  );
}
